<template>
    <div class="page roundBorder8 bgF5F5F5 max640" id="homePage">

        <header class="pageHeader" style="padding-top: 4px; padding-bottom: 4px;">
            <div class="inner">

                <div class="flexLayout generalPagePaddingH" data-notice="弹性布局">

                    <messageIcon/>

                    <div class="flexItem">
                        <!-- 搜索框 -->
                        <searchBox ref="searchBox" placeholder="点击搜索资料" :onClick="onClickSearchBox"/>
                    </div>

                    <div class="alignR" data-note="签到图标(已取消)" style="width: 52px;">
                        <router-link :to="{name : 'operationMainintegral'}" class="icon signInIcon fr"></router-link>
                    </div>
                </div>

                <!-- 广告图 -->
                <div class="generalPagePaddingH" style="margin-top: 12px;" data-notice="广告分类：首页顶部">
                    <bannerModule3 ref="bannerModule3" :itemCount="99" type="HOME_BANNER_TOP"/>
                </div>

                <div class="paddingH8 marginT8">
                    <latestContent/>
                </div>

                <datumMenuModule ref="datumMenuModule"/>

                <!-- 2022-10-28 刘薇决定：取消2个广告图，改为原来的1个。 -->
                <div class="paddingH8" data-notice="广告分类：免费学">
                    <oneImageAdModule version="4" categoryKey="HOME_FREE_LEARN"/>
                </div>


            </div>

        </header>

        <datumComp/>

        <adDialog ref="adDialog" :itemCount="99"/>

        <div class="appMessageBar" data-note="产品经理刘薇规划，每次进入首页展示，可关闭" v-show="appMessageBar.visible">
            <router-link :to="{name : 'appDownload'}" class="block paddingH16 paddingV10 font14r lineHeight20r14f">
                下载APP更方便、更多资源、更高清、更便宜
                <i class="icon closeIcon fr" style="margin-top: 3px;"
                   @click.prevent="appMessageBar.visible = false"></i>
            </router-link>
        </div>

        <bottomMenu ref="bottomMenu"/>

        <newPeopleGiftDialog ref="newPeopleGiftDialog"/>

<!--        <customService/>-->

        <notificationDialog ref="notificationDialog"/>

    </div>

</template>

<script>
// lib
import moment from 'moment';

// config
import appConfig from '../../appConfig';
import userApi from '@/api/user';
import agilityTitleApi from '@api/agilityTitle';

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// modules
import searchBox from '@comp/searchBox';
import bannerModule3 from '@/components/ad/bannerModule3';
// import freeCourseModule from '@/components/vodCourse/freeCourseModule';
// import todayUpdatedCourseModule from '@/components/vodCourse/todayUpdatedCourseModule';
import oneImageAdModule from '@/components/ad/oneImageAdModule';
import datumMenuModule from './datumMenuModule';
import messageIcon from "@comp/messageIcon";
import notificationDialog from "@comp/message/notificationDialog";
import latestContent    from "@/pages/discover/modules/latestContent";
// import parkListModule   from '@comp/humanResources/parkListModule';
import atlasList        from '@comp/atlas/atlasList';
import courseListModule from '@comp/vodCourse/courseListModule';
import articleList      from '@pages/article/articleList';
import goodsListModule  from '@comp/shop/goodsListModule';
import datum            from '@comp/datum/datum';
import datumComp        from './datumComp';
import poster           from '@pages/discover/poster';
import courseware       from '@pages/discover/courseware';
import recruit_poster   from '@comp/humanResources/recruit_poster';
import listen           from '../learn_secondary/listen';
import circleListForRecommend from "@pages/information/module/listForRecommend";


import adDialog from '@comp/ad/adDialog';   // 浮窗广告
import bottomMenu from '@comp/bottomMenu';
import newPeopleGiftDialog from "@comp/newPeopleGiftDialog";

// utils
import consoleApi from '@/components/platformApi/consoleApi';
import windowHelper from '@util/windowHelper';
import storageManager from '@comp/platformApi/storageManager';
import appHelper from "@util/appHelper";
import externalApp from "@data/externalApp";
import deviceHelper from "@util/deviceHelper";
import browserHelper from "@util/browserHelper";

export default {
    extends: shixunPagePart,
    components: {
        searchBox, bannerModule3, oneImageAdModule, datumMenuModule,
        // freeCourseModule,
        latestContent,
        // scrambleCourseModule,
        bottomMenu, adDialog,
        // todayUpdatedCourseModule,
        // courseMonthlyModule, courseModuleNewsLayout, courseModuleHorizontalLayout, courseModuleTableTwoColumnsLayout,
        // liveTelecastModule, themeGroupModule, lecturerModule, topicModule,
        newPeopleGiftDialog, messageIcon,
        // customService,
        notificationDialog,
        // parkListModule,
        atlasList, courseListModule, articleList, goodsListModule, datum,
        poster, courseware, recruit_poster, listen,
        datumComp
    },
    data() {
        return {
            title: '首页',
            pageKey: 'index',
            courseModule1: {
                itemCount: 4,
                dataParams: {}
            },
            scrambleCourseModule1: {
                itemCount: 4
            },
            newsModule1: {
                itemCount: 4
            },
            windowHelper: windowHelper,
            moduleStyle: {
                title: 'font-size: 112.5%; font-weight: bold; color: black;'
            },

            appMessageBar: {
                visible: false
            },

            tabModule : {
                panelItems : [{
                    title : '环创',
                    id : 'atlas'
                }, {
                    title : '商城',
                    id : 'shop'
                },{
                    title : '课程',
                    id : 'vod_course'
                },{
                    title : '资料',
                    id : 'datum'
                },
                // {
                //     title : '海报',
                //     id : 'poster'
                // },
                // {
                //     title : '听书',
                //     id : 'audioCourse'
                // },
                // {
                //     title : '资讯',
                //     id : 'article'
                // },
                // {
                //     title : '师圈',
                //     id : 'circle'
                // },
                // {
                //     title : '课件',
                //     id : 'courseware'
                // },
                // {
                //     title : '招聘',
                //     id : 'recruit'
                // }
                ],
                // type: object|null
                activePanelItem : null
            }

        }
    },
    methods: {
        onClickSearchBox: function () {
            consoleApi.log('[home page] 点击搜索栏，转到搜索页。');
            this.$router.push({name: 'search'})
        },
        clickTabItem(tabItem) {

            this.tabModule.activePanelItem = tabItem;
            // if (tabItem.id === 'news')
            // {
            //     appHelper.goToPage('articleIndex');
            // }
            // if (tabItem.id === 'information')
            // {
            //     appHelper.goToPage('informationIndex');
            // }
            // if (tabItem.id === 'datum')
            // {
            //     appHelper.goToPage('datumIndex');
            // }
            // if (tabItem.id === 'atlas')
            // {
            //     appHelper.goToPage('atlasIndex');
            // }
            // if (tabItem.id === 'shop')
            // {
            //     appHelper.goToPage('shopGoodsList');
            // }

        },
        viewMenu(name) {
            appHelper.goToPage(name);
        },
        setTab(type) {

            for (let i=0; i<this.tabModule.panelItems.length; i++)
            {
                if (this.tabModule.panelItems[i].id === type)
                {
                    this.tabModule.activePanelItem = this.tabModule.panelItems[i];
                }
            }
        },
        goToArticlePage() {
            appHelper.goToPage('articleIndex');
        },
        goToRecruitApp() {
            appHelper.redirect(externalApp.rcWebApp.url);
        },
        onClickWeAppLink() {
            if (deviceHelper.isBrowser && !browserHelper.isWechat)
            {
                appHelper.showHint('只能在微信里面打开小程序');
            }
        },
    },
    mounted() {


        const me = this;

        (function () {

            let home_ad_latest_show_time = storageManager.getItem('home_ad_latest_show_time');

            // 1 day
            if (!home_ad_latest_show_time || moment(home_ad_latest_show_time).format(
                'x') < new Date().getTime() - 1000 * 60 * 60 * 24) {

                me.$refs.adDialog.loadAd({
                    typeEnum: 'HOME_OPEN_WINDOW',
                    limit: 3
                }, function callback(error, data) {

                    if (error) {
                        return
                    }

                    if (data.length) {
                        let now = moment().format('YYYY-MM-DD HH:mm');
                        storageManager.setItem('home_ad_latest_show_time', now);
                    }
                });

                userApi.getUserVipInfo((data) => {
                    let timeout = '';
                    let now_time = moment().format('YYYY-MM-DD HH:mm:ss');
                    let vip_time = '';
                    for (let i in data)
                    {
                        vip_time = data[i];

                        // 10天内过期，计算N天后过期
                        if (vip_time > now_time && vip_time < moment().add('30', 'days').format('YYYY-MM-DD HH:mm:ss'))
                        {
                            timeout = vip_time;

                            let gap = moment(timeout, 'YYYY-MM-DD HH:mm:ss').toDate().getTime() - new Date().getTime();
                            gap = Math.ceil(gap / 1000 / 60 / 60 / 24);

                            // alert
                            appHelper.confirm({
                                title : '会员续费提醒',
                                content : '您的会员将在' + gap + '天后过期，请尽快续费，否则将无法使用对应会员权益！',
                                okText : '立即续费',
                                cancelText : '关闭'
                            }, (status) => {
                                if (!status)
                                {
                                    return;
                                }
                                appHelper.goToPage('shixunVip');
                            });

                            return;
                        }
                    }
                });
            }

            // get dynamic title
            agilityTitleApi.getByLocationType('2', (result) => {
                appHelper.setTitle(result.data, true);
            });


            // me.$refs.adDialog.loadAd({
            //     typeEnum: 'HOME_OPEN_WINDOW',
            //     limit: 3
            // }, function callback(error, data) {
            //
            //     if (error) {
            //         return
            //     }
            //
            //     if (data.length) {
            //         let now = moment().format('YYYY-MM-DD HH:mm');
            //         storageManager.setItem('home_ad_latest_show_time', now);
            //     }
            // });

        })();

        //ad end

        this.tabModule.activePanelItem = this.tabModule.panelItems[0];

        // (function(){
        //     userApi.getBindPhoneStatus((status) => {
        //         if (status)
        //         {
        //             consoleApi.log('[user] 已绑定手机，无须进行认证。');
        //             return;
        //         }
        //
        //         appHelper.confirm({
        //             title : '身份验证',
        //             content : '介于师讯平台做了大的升级，为了保证您的正常使用，希望您进行身份验证，非常感谢！',
        //             okText : '去认证',
        //             cancelText : '我再想想'
        //         }, (status) => {
        //             if (!status)
        //             {
        //                 return;
        //             }
        //
        //             appHelper.goToPage('bindPhone');
        //         });
        //     });
        //
        // })();

        // this.$refs.notificationDialog.show();

    }
};

</script>
<style lang="scss" scoped>

.pageHeader {
    background-color: white;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAF4CAYAAACVT5M0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAUUlEQVQ4jWP4/+H2fyYGBgYGGMHIgMLFIsaIXzEuCUZSFCPEGIlQjNORJFmJ05GETSHGkdiChBTFIykQSUpXJAciAyOWIKFi4h8lRolRYkQTAK/2BuvT1Xg7AAAAAElFTkSuQmCC');
    background-repeat: repeat-x;
    background-size: 100% 376px;
}

.signInIcon {
    width: 40px;
    height: 38px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABMCAYAAAD6BTBNAAASGUlEQVR4nO2baVCUV7rH32SWm3uvM2WmMlWpmXy4H+ZWzYe5VXNnJpVMxoygxhix30YEFWRpFpegiAhiRM0lY6LRGM062UxgzKJBnRhoUBDoZkeCMiqCIA2yiaDIvjXd/bsfzgvdNE2zmKSNyVv1L+jtPef8zrOc85xuSXLRRYnmYVe1/Z2/KAj0piDomKv78Z28KPV9yFIY2GgpCKx0dV8kSZLYs8eN+PhZru7HlC8KAlMs+YEtFGn+y+V9iY//Mbv3VbJn73ZX92VKl7kg8DVLQUAP+QF/cnVfJEmSeGnvfnbvhT171rm6L5NeFARFWwoChykO9Hd1XyRJkti9bwm798JLe192dV+mdFHq+xCF/r9xdT8kSZJ48eU57N7bw+69R13dl+/cxb59D7N7bw97Xi79TiWPu+nipX2/Jz7+gW+ugeJVj5gLg2Km/Tkfnx8hyyuR5S+R5WZk2Ygs42IZlb6cRJZXEh9/v8O+v/32LA4ciOTAgTIOHvz9nQEs1CyyFAQOUKj57ZQ/4+X1CLJceRcAcy61+hJeXo+Mg3fwoI4DB4o4eDCB/fsfuiOAkiRJ5oLAeAoCL6HzmTRO4OHxILJ8xeVwpq4reHg8eMeQJoWYH/AJBYF5k0FErX77LoAyXUt84xsHiM5nljnfP4ZS3wlNGje3Wchyn8uBTF99uLm5Pgsjyx53AYyZapGr+UnI8rq7AMRM5fotHGr1Vqed9JdhjQxhMvjKoHY5NFttcTU/CVmOHdcxbxn2qSFFDdmeY5XuCYfUEKOGpV8zEG8ZNsoQL8NOZdKcfybW1fzGAwyXIVmBlesN50OhPBwq1sPFtVDsD7ql4vUv1BCrvnNwfjK8roZMz3ETZj6uYnj7IixLVXc/QEu4CssZtQB0eT0074Trz49X43YBM2eZGOi7amE9M4G3SYY0ZbIurIHaLdC8A+q3QcUGyFuOJUtN78dPYgp45u4FOKxZhOm0hwBSE+0YnL0a4qBUo1ijJ2gmgeUpwwqbx8/JkOUJJYHQtN1xG03bodAXS6ZMV8LjWLyX3H0ALWoVfYl/FSD+FTYleJaGOOvjy+His2meEGIHzUuGF9SQZOOiaWr4uwKvLHRiSx9R/XOgW8pA6nx6dz159wEcjFjAQOp8Mbi6WOfgardiLAzBeDYU04XVWAp9hcuPxMUv1bBSGeAGWTwuCYSazcKamnbA1Sgo9seSrcZcs3lq1n4+BEumTPvRP2BesfjuAWhWqbZ2HXgc46lFAsIkAzF+tYa+U2oG0hZCno9ILrVbwBAtYliONxxVw9+UDF4Z4fhezTuhaBWDWSrMNTFY6rc5b7s6CrI96TrxOP3Pud0dAH0k6UdDsryt7b1HGUhdhFnvg6V5p1OXGizW0HNyDuQtF67lKGYVrRKTUb0Jrj+PuToaS6ODGFcTzXDGYnrTVRgLgzHXbLFauiGW4fPrMF2KEP1piINsT3pPzqH75SewqFSYVaqtkiTd5yp+973xzDP/dnPx4v9reOdR2o89TV/aUoZqt2Nq2IG5Pg7juXUM5QRgrrK6WVfaAkwZiye2rIZtoPeCqsjR54bPr8NUvtFBNo+DbDVdKfMwFgYzXPasMgk7MJaECajV0Viad2Jp3okp05Puf87l5huPM6hSMaBSxcW7uf3YdlAk/fLbOXZAku57ZeHC/2xasmRX9YHHuJawgLbPVXSc30xP5XP0lW2kN8OP/vSVDGSsxFi6FnNdLB3HHhXW5ciirj8P54LhrP+Y50wXN2C6uEFY45UojKVrsNRtFbCz1HSmzB0FZqmPw3QpgqECDcbz6zA37sTUsIOh2u30p8q0fjaXhv2P06FS0bpkSXyUj8+/A/dJkiRxbPYOjs3+1g7874v9y19+1uW97ED7hoVUH5jLtUQVjafCuFEcza3zW+i8sIVOXQid2hX0pK2gO82TzuNPYNEtw9K0E1NFJEP5GsyGWCzNOzFXiTjFta2j8MyVmzCeDWO47FlM5REYi0MxVUYJN62KxJThQecXT2IsWc1gvoah0nUM5Groz9UweDma/qtx9FY8R+f5zdxMkjG8/yTVL86hy9uL2yu9X4mV5Z/FS9L9kiRJfD47nmOzO9BJP55k7F8fwG6/5QcI9MOyyofOTTKNby2jLjOSev0mmvKjuHE2mtaccG6cWE7L0UW0HZnDQKYPQ4btDBni6Mvypz8nCFP9DoYKNZhzfDA37sTcuEOoPo7hy5EMFoYwWBDC0DnFqhp3YioNpS95AR3aRfSXrKNHr6ErM5DbGYHcOhVA6ykNbaUxtBRF05ixlutvqmnfosIUvBIC/ejyXX4w/rHHfj4KMOmXD3PswQGOPrjkWwc4qlUr6A9fQdurGuqSN1CXFUnNZ74YDntj+FiF4YM53DzpTXvZFjouxNJxNoJbJ5fTmbuaruRl9OcF0V+9jYGrcfRXxtKTF0ZPXhjd+mD6yqPpLYukvzqOvopYetO8uH74z9zSB9FxIZa27LU0n/Sn6VQYTflRNGRvpCk5gtuvrWZogz9j+ukAoIA4+xDHHkxxHUBb+S2nN8qPthdW0vBRCFUngrj02p+5lqiiITuCxrworp0I4NqRFdR/6kPzkaW0pgXQ9lUMbaUx3CyN4eZX0bSkBtGSquF6WjCtRVG0lcTQmupP4+GFVH3wV+pPBFD7uR+GI37UHPal6S1/2ndrGIgKcNwvZwCPP/Qnjs2GE7943PUAbeW/ErOfN12hHtyOlrmxfxUNn6yh9mQ4NWnhXPnQh6sJy6g9soK6rEirzkRQc0JDXfoGajMiqMuKpPbLEAwfelD+yhPUv+tH28FgOp8PYGCDH5agKfTFCUBJkiSSfuFN0s+/8Ww8PYCOFOALfiuw+HozHOjNQOgyetd70bU9kM54DR0vhXD75VA6d4XQvT2IvpgABtf7MRy8AnPgypm1OQWA39Z15wBdrB8AflcAUpcwe8zjBGn2DwCnCq/m0O8wJOZJkiSRJM3ic+kdPpcW/ABwKvDqEh7GkNiIIRFqDv2Oo1IYn0kjX/e45wHSlLoDdDPblVBz6DcYEisxJIIhEWo/8rZ7yz0NkLbUh2nSQnPaK9OHV53wewyJLQq8YQwJmxy87d4G2JgaRpMWGlPipwev9iNvDIk9CrxGDB/OmeCt9zbAZu0ZmlIHuJ4ytW9qcfntWdQmvjnqsjUJeuoSnP0Y5p4FSFPaIzRph2nSvjs1eHUJD9i4LBgSDqGLnyx43sMAtftp0sL1lCl/P1Ki5qMXqU08gyFhqt8XuScBCutLHaBJq5syvBle9wTAyqSk/7mekvIfowBvaH9Hs/bItKzv+wzQkJz8KJcvfzPf0oJuZxnongAY/9hjPzeXl7/w9cMbuvVbhm6f/D4ApKzsv79eeHQ/xFDni1D3AFr3P5Li/iraecUkuzeQMs9IynxIWQDaET2laCGkLoTUpxUtEkp7RtFiRR5wygNOLbGRCk6r4LSsSK1I+Upc+lJFXkIZyxR5W3XGR9FyRSsgcwVkrlTkK5Tlp2iVIn/I9ofsACPZAQ1kBxSjC3yF3OA/zBCgdD8n5y4lxS2XZHdIdoeUeYrmMxagDbwZA1QpAOXxANMdAMxwANARvOkDVBQopAsCXVAuOo0nOP59yXh4ST4/JcX9dZLdLCS7KfAcAHRkfVoH8FKfmQHAiaxvmgAdwnMAMNsBQN0oQNAFWdAHvz7p2pj3/vgTkt31ApwCz6H1TQBwWtY3E4D27jsTgBNZnzOAGqEcTSala37iGF58/P2kzP3UCs8ZQHt4dxL/vgn3nVH8s3NfBwD1waDTfOLw52J86b55LDwn7jth/LN335kAtLe+Gca/MfBWTs99sx3A0wULgPpgyAmNHAsvZd6vSXbrd2p96V5Q9rIYnL37XnhVNDCp9U0RYN56yFnj3H3/tRf0IdN33/O74eLBsQD/tQ8Ko5y77wg8fQjoQ3ooDPy1DUC3dxxany3AqkSwmCEnTBnMMjglQ/FWALiwHzJ8hEYGMgLwwqtQ8S5UvGen96HyfchdJyzutKcA2F0LzbqJre+s0mblIaW9SQCW7IBzuwTAG0XQWW1133O7wGKCpizICxfKXw+5a5wBhJxgUalB5zaL5Ll9TgGmPQODtxl3tRZDX/P45wFMA1aAty5A33UY7hOv9beIx30tQud2iftf/dQxwIp3ofIDAazyELR9Je5TexyufKjoIzslWAHWp4CxW0yULcDzL8Jwr+P+D/dD7tqJAepDe9CFz5JInus7MTwF4DUtmIegKBqMPVB3UnSg+hMBpSASCjaBaRBqv7DGE1v3Pa2G/htws1S4bO0JOBtndV+HABXrM/aI9s1DYDaKAVpMNs9NoBHX1QXBUCfU/dMKsPpjcY/2i1AaD2efg7PbxP/GHmgrcQIvBPShoA/2ldC6v+fU+nQaMA+LWU5ZADWfQ0eliD2dVTDYLmJZ6tMCwFCHGLR9/Kt4Xwwqd514/7UvBbTswMkB2sa/2hOABYpiphf/SuKgYKO4d2c1FMdCzVHRj74WKNwkxtpSILynKNqZ9UFOKOSEvSeR7HZ+0vin04ikkbJALIzPbhPW1FULXVcFyNy1Akyax/gEUrhZWGe3QVhvc7Zw65Ew4BCgfnz8K4oWVtPfNt5dryRAlSJ96FiAec9CfaqYQFBcWMm++lDouCLCyu1y4dKlLziPf1aAJRIp7u1O3dd2+ZIXDi15wgLq06wZtCFNJJimLMiPGL/7KI4Vrt5VC22l0HQGDMdFDDMNQc5qG4CejgGeWQ5dBgHA2C0m0F6DHeL1ohgrvJzVYvKM3SIRtpUIgNn+IlFcfA1unhef66mHku0TLF9CHAFsl0h2H3JqfafVopH2i6KRgTbx/9UjUDOio+K5nmsCblctXP1MZL20xTbLFg+xFGq/YC0e6ILsLNAeoJdw1ZYCcW+AqsOO3bdsz3iAmb5Q/qYYdNYqaFViYFOWuJ/FJCzw0uu2W7epWB/khA1NDWBPAzSmK2l+vQjErcXjlR0k1m91/4QbhYpLLxYg8zcI66w9IRJBfoSISfkbxwJM94TuOivA7AC4eU5Y+OV3BaC+Fmi/NF491xwDtF08XzwosnpBJNwqE5M/2e7DKUBHLmzvvtoFYqdxbpeYee1TYsZbiyDTz7p4zguHxgzRedsEcuUjx0sFEGBOqycGqAsSrlW2V7QJIn4akhQds6olzwagDbyqfwirrToM1TYy9grjqP5Y6Oonij4Vf213H44BttslESfFgzQPMfPNOgEw9WkxsGtaK8BmHfQ2jd95ZHhbZ/XqZ8ICbTs3IUAva/zLWGYFWHtcxK/ctTZaB+VvOQY4cHO8jD3WSRzqgIFbdrrpBN4owBK7ZcwkxYOSnaLBwihhkRdfEwE6YxnoQkQ8ufia871v5QciG44UT/VhIo4ZjsO5v40HaLv3HQE42WUPcFzxIABuXxaJzdgrws3049/IMmaer1P3tS8e3CiEr54XANO9hBtlLIfWs9DbqMQ9BwAzfcW277peuG1HhXVnUhQztngwGcC6L0QMzd8o4mhBpFDFe2MBOioe5IXDzTLxvsvviH2wxSwycWGUTfadAkB9mK+ylXPrGW99NgAvvaFspT4Yu6UaUe1x0aHWs9ZtVfmbVoC9TVbrMPXD7Qqo18KlN8UaMd1LLICr/iFk7IKGUxMDrD48NvsWbBSDH4m1hZvHWl9RjIB1o1BsCob7oPwNa/GgbI8IIRazWAvWHBXJJi98YvfNDe1CFz5LKSa4/92p+94uF3vevmZlDzsF3b5ktb6LB8XyJXetUnFxUL5K9xQ7HGO3WFYURY8/+5gIYL3WOkH9NwSYEYD6YBHTzEax4K8+LNaG9sXTnNVi8jsqRFjquy76O7H7vmVTC3zqV6NWOO3a350UT9VMq3h6xlvEybxnx27dcteIsFK0RcQ4+/iXHyFc0vnZhzX+6UNERWZi9+0hP+RXdjVBt8gpn304qjx/rWcfXo4Bzqh0P52zj0mKB6MA7QqqoyV9rftnjq3vXjq6nAnAMdbnuKRvPVSal/6dOrrM/FqOLqcIMFQ74aHSKMQkn5+SMv/179/RpYOzD1uAuaGvkuTzU6fwxoBMnf8U2vm537ujy3Gl+9BcdKsXTBncOJDahX8k9alXSV1YTMrCBlIXGu8O9/0Gji71miH0wfXogovJCd5PYej/Tsbn/wFhcHSSVZPaIAAAAABJRU5ErkJggg==');
}

.appMessageBar {
    position: fixed;
    z-index: 110;
    width: 100%;
    bottom: 53px;
    left: 0;
    background: linear-gradient(153deg, #FFF2E0 0%, #FFE2B5 100%);
    color: hsla(36, 77%, 45%, 1);

    a {
        color: inherit;
    }

    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABhUlEQVRIie3VPU4CQRQH8C0oOQAdJPMf5COxsCfhEHAAOytCtPMKJngDynnjwh3oNBa2cAKhISE0GknYvwXr8CHgLrCFCS/ZZmff+82b5O143jnO8S+DfjlNv5w5Ij9Dv5yOniAY0OKDglpsTFCj4JOCQbSEXjVFwZgCUvAVB6VFPcwhDcbsVVPREjv5CkVPHWpRj4bp2SJHT9nJV6Ju9KfAFUUPwwKzfegaZvU7zcVlLMwV8lGiqAVqMaPR17++EX1DixBTI/ooHYQtd6+LFDUKCwY0aLo1gyatChanoEa02eJR2BLNFl2nokiDJg2aFMXw3fBk2HZ09UkAc2g3X6BVE4dZTNjNFxLBPM/zKLqxmDG12mEjIQz3FDUPO+tT0A/BOS1uT421HCYY0M9l6OcyFAwcKmglhrm1U6MhFmzDdqDBwSgtHv/CdqIWj/Gw9c5e92Eb6NuyU/0QDetVU+4P8oTnOBcp/XKaFi9uZCJfT0bd0aAd69ZeRQ3aFJ3MfJ5jM74BAJKUXsNMH2gAAAAASUVORK5CYII=');
    }
}

.discoverModule {
    .moduleHeader {
        .moduleTitle {
            width: 89px;
            height: 31px;
            background-image: url('data:image/png;base64,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');
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
}

.tabModule {
    .tabHeader {
        .tabItem {
            position: relative;
            display: inline-block;
            margin-right: 24px;
            padding-bottom: 6px;
            font-size: 16px;
        }
        .tabItem:last-child {
            margin-right: 0;
        }
        .tabItem.active:before {
            content: '';
            position: absolute;
            z-index: 1;
            width: 14px;
            height: 2px;
            bottom: 0;
            left: 50%;
            margin-left: -7px;
            background: #FFA724;
            border-radius: 2px;
        }
    }
}
</style>

